import { color } from "style/constants";

export default {
  root: {
    backgroundColor: color.WHITE,
    borderRadius: "8px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.2)",
    color: color.BLACK
  }
};
